module.exports = __webpack_public_path__ + "static/media/organization-freelancer-hero-image.0ecb5cae.webp";